import LoyaltyPrograms from "@/models/loyaltyPanel/LoyaltyPrograms";

export default {
    namespaced: true,

    state: () => ({
        loyaltyPrograms: [],
        loyaltyProgram: (new LoyaltyPrograms({})),
        pagination: {
            total: 12
        }
    }),

    mutations: {
        setLoyaltyPrograms(state, payload) {
            state.loyaltyPrograms = payload;
        },

        setLoyaltyProgram(state, payload) {
            state.loyaltyProgram = new LoyaltyPrograms(payload);
        },

        setPagination(state, payload) {
            state.pagination = payload;
        }
    },

    actions: {
        async fetchLoyaltyPrograms({ commit }, query = '') {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await LoyaltyPrograms.get(query);

                commit("setLoyaltyPrograms", data.data.sub_loyalties	);
                commit("setPagination", data.data.pagination);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async createLoyaltyProgram({ commit, dispatch, state }, logo) {
            try {
                commit("setLoading", true, { root: true });
                let item = {...state.loyaltyProgram}
                let res = await LoyaltyPrograms.create(item);
                if(res && !res.data.error){
                    if (logo) {
                        dispatch("uploadLoyaltyProgramLogo", {
                            ...res.data.data.sub_loyalty,
                            logo,
                        })
                    }else {
                        dispatch("fetchLoyaltyPrograms","?page=1");
                    }

                }
              
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },
                    {root: true}
                );
            }
        },
        
        async updateLoyaltyProgram({ commit, dispatch, state }, logo) {
            try {
                commit("setLoading", true, { root: true });
                let item = {...state.loyaltyProgram}

                let res = await LoyaltyPrograms.update(item.loyalty_program_id, item);

                if(res && !res.data.error){
                    if (logo) {
                        await dispatch("uploadLoyaltyProgramLogo", {
                            ...res.data.data.sub_loyalty,
                            logo,
                        })
                    }else {
                        dispatch("fetchLoyaltyPrograms","?page=1");
                    }
                    

                }
                commit("setDialog", false, { root: true });
               
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },
                    {root: true}
                );
            }
        },
        async toggleActive({ commit, dispatch, state }, payload) {
            try {

                let res = await LoyaltyPrograms.toggleActive(payload.id, payload.body);
                return res

            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message
                    },
                    {root: true}
                );
            }
        },
        
        async uploadLoyaltyProgramLogo({ commit, dispatch, state }, payload) {
            try {
                commit("setLoading", true, { root: true });
                console.log('payload', payload)
                if (payload.loyalty_program_id) {
                    const fd = new FormData();
                    fd.append("loyalty_logo", payload.logo);
                    const { data } = await LoyaltyPrograms.uploadLogo(payload.loyalty_program_id, fd);
                }
                dispatch("fetchLoyaltyPrograms","?page=1");
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },
                    {root: true}
                );
            }
        },

        async deleteLoyaltyProgram({ commit, dispatch }, id) {
            try {
                commit("setLoading", true, { root: true });

                await LoyaltyPrograms.delete(id);

                dispatch("fetchLoyaltyPrograms");
                
                commit("setLoading", false, { root: true });
              
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },
    }
};
